// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__12H_c","label":"CategoryService_label__2IR4M","location":"CategoryService_location__1T0-C"};